
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of Stotra "Jayjayaji Ganpati" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: 'Explore the full lyrics of Stotra "Jayjayaji Ganpati" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property:'twitter:description',
            content:'Jayjayaji Ganpati, Ganapati Stotra, Lord Ganesha stotra, Ganpati stotra lyrics, Ganpati stotra lyrics marathi, Ganpati stotra lyrics english'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Jayjayaji Ganpati, Ganapati Stotra, Ganpati prayer, Lord Ganesha stotra, Ganapati chant, Devotional stotra, Ganpati stotra lyrics, Ganesh mantra, Worship of Lord Ganesha, jay jayaji ganpati ganpati stotra, jay jayaji ganpati ganpati stotra lyrics, jay jayaji ganpati ganpati stotra marathi, jay jayaji ganpati ganpati stotra english, जय जयाजी गणपती स्तोत्र, श्री गणपती स्तोत्र' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/stotra/ganpati.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/stotra/ganpati.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Jayjayaji Ganpati | Ganapati Stotra - जयजयाजी गणपती (गणपतिस्तोत्रं)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/stotra/ganpati"
        },
        "headline": "Jayjayaji Ganpati - जयजयाजी गणपती (गणपतिस्तोत्रं)",
        "name" : "Jayjayaji Ganpati - Ganapati Stotra",
        "description": "Explore the full lyrics of stotra 'Jayjayaji Ganpati' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/stotra/ganpati.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  